import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function Footer() {
  const [site, setSite] = useState({
    name: 'Revival Pharmacy',
    phone: '(306) 559-3228',
    alternatePhone: '',
    email: 'bhavya@revivalpharmacy.ca',
    address: '1168 Albert Street, Regina, SK, S4R 2R1, Canada',
  });

  useEffect(() => {
    api.publicSettings().then(setSite).catch(() => {});
  }, []);

  const addressParts = site.address.split(',').map((part) => part.trim());

  return (
    <div className="site-footer-wrapper">
      <footer className="footer-section">
        <div className="container">
          <div className="footer-layout">
            {/* Column 1: Logo & Contact Info */}
            <div className="footer-col-contact">
              <div className="footer-brand-logo">
                <a href="/Home/Index" aria-label={`${site.name} Home`}>
                  <img src="/assets/image/main logo.png" alt="Revival Pharmacy" />
                </a>
              </div>
              <div className="footer-contact-details">
                <div className="contact-line contact-line-address">
                  <span className="contact-icon fa fa-map-marker" aria-hidden="true"></span>
                  <div className="contact-text-wrap">
                    <span>{addressParts.slice(0, 2).join(', ')}</span>
                    <span>{addressParts.slice(2).join(', ')}</span>
                  </div>
                </div>

                <div className="contact-line contact-line-phones">
                  {[site.phone, site.alternatePhone]
                    .filter((phone, index, phones) => phone && phones.indexOf(phone) === index)
                    .map((phone) => (
                      <div className="phone-entry" key={phone}>
                        <span className="contact-icon phone-icon fa fa-phone" aria-hidden="true"></span>
                        <a href={`tel:${phone}`}>{phone}</a>
                      </div>
                    ))}
                </div>

                <div className="contact-line contact-line-email">
                  <span className="contact-icon fa fa-envelope" aria-hidden="true"></span>
                  <div className="contact-text-wrap">
                    <a href={`mailto:${site.email}`}>{site.email}</a>
                  </div>
                </div>

                <div className="contact-line contact-line-fax">
                  <span className="contact-icon fa fa-fax" aria-hidden="true"></span>
                  <div className="contact-text-wrap">
                    <a href="tel:+13062052381">(306) 205-2381</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Column 2: About Us */}
            <div className="footer-col-about">
              <h2 className="footer-badge-title about-title">ABOUT US</h2>
              <div className="about-text-wrap">
                <p>
                  {site.name}, centrally located in Regina, Canada, is committed to delivering outstanding care and tailored solutions to our local residents. Emphasizing wellness and accessibility, we aim to rejuvenate your path to health with professional support and empathetic service.
                </p>
                <div className="footer-about-divider" aria-hidden="true"></div>
              </div>
            </div>

            {/* Column 3: Quick Links */}
            <div className="footer-col-links">
              <h2 className="footer-badge-title links-title">QUICK LINKS</h2>
              <ul className="footer-nav-list">
                <li><a href="/Home/Index" id="footer-Home" className="active-link">Home</a></li>
                <li><a href="/Home/About" id="footer-About">Minor Ailments</a></li>
                <li><a href="/Home/Contact" id="footer-Contact">Service</a></li>
                 <li><a href="/Home/Gallery" id="footer-Gallery">Gallery</a></li>
                <li><a href="/Home/Info" id="footer-Info">Contact</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Footer Bottom Bar */}
      <div className="footer-bottom-strip">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="bottom-copyright">
              <p>© 2024 <strong>Revival Pharmacy</strong> All rights reserved.</p>
            </div>
            <div className="bottom-nav-links">
              <a href="#privacy">Privacy Policy</a>
              <span className="bottom-divider">/</span>
              <a href="#terms">Terms &amp; Conditions</a>
              <span className="bottom-divider">/</span>
              <a href="#help">Help Center</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
